import { createFileRoute, redirect } from '@tanstack/react-router'
import { ServiceMap } from '../../../../features/serviceManagement/serviceMap/serviceMap.tsx'
import { urlHash } from '../../../../router.tsx'
import { useMapState } from '../../../../states.ts'

export const Route = createFileRoute('/_app/smp/serviceMap/')({
	beforeLoad: ({ cause, search }) => {
		if (cause !== 'enter') return
		const existingHash = urlHash.get()
		if (existingHash.lat !== undefined && existingHash.lon !== undefined) return
		const { viewState } = useMapState.getState()
		if (viewState) {
			throw redirect({ to: '/smp/serviceMap', search, hash: urlHash.format(viewState) })
		}
	},
	component: ServiceMap,
})
